import CurrencyLogo from 'components/CurrencyLogo'
import Tag from 'components/Tag'
import React from 'react'

import { EntriesStyled, PoolCardStyled } from './styled'
import { SkeletonText } from 'components/Skeleton'
import { ETHER } from '@uniswap/sdk-core'
import { ReactComponent as ImperatorLogoWhite } from '../../../assets/imperator-logo-full-white.svg'

const IS_DISABLED = true

const HypePoolCard: React.FC = () => {
  return (
    <PoolCardStyled role="button" to={`/stake/HYPE`} disabled={IS_DISABLED}>
      <div className="poolCard__tag">
        {IS_DISABLED ? <Tag variant={1}>Inactive</Tag> : <Tag variant={2}>Active</Tag>}
      </div>

      <div className="poolCard__header">
        <CurrencyLogo currency={ETHER} size={'42px'} />
        <h2>Delegate HYPE</h2>
      </div>
      <div className="poolCard__subheader">
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          <span>Powered by</span>
          <ImperatorLogoWhite />
          <span>Imperator</span>
        </div>
      </div>
      <EntriesStyled>
        <span style={{ fontWeight: 500, fontSize: '14px' }}>APR</span>
        <span style={{ fontWeight: 500, fontSize: '14px' }}>TVL</span>
        <span style={{ height: '16px' }}>
          <SkeletonText width="50%" height="100%" />
        </span>
        <span style={{ height: '16px' }}>
          <SkeletonText width="80%" height="100%" />
        </span>
      </EntriesStyled>
    </PoolCardStyled>
  )
}
export default HypePoolCard
